import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useParams, useNavigate, useLocation } from 'react-router-dom';
import PortfolioOverview from './components/PortfolioOverview';
import IntroGate from './components/IntroGate';
import VirtualGallery from './components/VirtualGallery';
import LoadingTransition from './components/LoadingTransition';
import { mediaItems } from './media';

// Main Portfolio Component with routing logic
const PortfolioApp = () => {
  const [selectedArtwork, setSelectedArtwork] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  // Determine current page from URL
  const is3DGallery = location.pathname.includes('/gallery/3d');
  const isLoadingPage = location.pathname.includes('/loading');

  // Handle entering loading transition from overview
  const handleEnter3D = () => {
    setIsLoading(true);
    navigate('/loading');
  };

  // Handle loading completion - go to 3D gallery
  const handleLoadingComplete = () => {
    setIsLoading(false);
    navigate('/gallery/3d');
  };

  // Handle artwork selection
  const handleArtworkSelect = (artwork) => {
    setSelectedArtwork(artwork);
    navigate(`/gallery/3d/artwork/${artwork.id}`);
  };

  return (
    <div className="w-full h-screen">
      {isLoadingPage ? (
        <LoadingTransition 
          onLoadingComplete={handleLoadingComplete}
        />
      ) : is3DGallery ? (
        <VirtualGallery 
          mediaItems={mediaItems}
          onArtworkSelect={handleArtworkSelect}
          selectedArtwork={selectedArtwork}
        />
      ) : (
        <PortfolioOverview 
          onEnter3D={handleEnter3D}
        />
      )}
    </div>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PortfolioApp />} />
        <Route path="/loading" element={<PortfolioApp />} />
        <Route path="/gallery/3d" element={<PortfolioApp />} />
        <Route path="/gallery/3d/artwork/:id" element={<PortfolioApp />} />
      </Routes>
    </Router>
  );
}

export default App;
